import React from 'react';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import ExternalProfile from './ExternalProfile';
import InternalProfile from './InternalProfile';
import { useAdminDetailByIdQuery } from 'redux/reducers/user/dashboard/tms-dashboardTrainee';
import ModalForm from 'components/ui/Modal/UserModal';

const ProfileDetailModal: React.FC<{
  lecturerId: string;
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ modalOpen, setModalOpen, lecturerId }) => {
  const { data, isLoading: isAdminDetailLoading } =
    useAdminDetailByIdQuery(lecturerId);
    const adminDetail=data?.data

  return (
    <>
      <ModalForm title="Lecturer Profile" open={modalOpen} modalSize="lg">
        <Box>
          {adminDetail?.user_type == '3' ? (
            <ExternalProfile
              adminDetail={adminDetail}
              isAdminDetailLoading={isAdminDetailLoading}
            />
          ) : (
            <InternalProfile
              adminDetail={adminDetail}
              isAdminDetailLoading={isAdminDetailLoading}
            />
          )}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button title="close" variant="contained" onClick={() => setModalOpen(false)}>
            Close{' '}
          </Button>
        </Box>
      </ModalForm>
    </>
  );
};

export default ProfileDetailModal;
